<template>
  <div>
    <p>Trang chủ</p>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'HomeIndex',
  metaInfo () {
    return {
      title: 'Trang chủ'
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  mounted () {
    this.configBreadcrumb()
    if (this.accountInfo.user_type === 1) {
      this.$router.push({name: 'home-admin-index'})
    }
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' }
      ]
      this.setBreadcrumb(breadcrumb)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/home/Index.vue